module.exports = {
	init: function () {
		// GF triggers this on the page's global jQuery, not the copy bundled here
		var jq = window.jQuery;
		if (!jq) {
			return;
		}

		// After a submission with errors, move focus to the first invalid field
		// instead of GF's validation summary. The field's aria-describedby points
		// at its error message, so screen readers read the label and the error.
		jq(document).on('gform_post_render', function (event, formId) {
			var wrapper = document.getElementById('gform_wrapper_' + formId);
			var summary = wrapper && wrapper.querySelector('.gform_validation_errors');
			if (!summary) {
				return;
			}

			var control = null;
			var fields = wrapper.querySelectorAll('.gfield_error');
			for (var i = 0; i < fields.length && !control; i++) {
				var candidates = fields[i].querySelectorAll('input:not([type="hidden"]), select, textarea');
				for (var j = 0; j < candidates.length; j++) {
					if (candidates[j].getClientRects().length) {
						control = candidates[j];
						break;
					}
				}
			}

			if (control) {
				// Moving focus interrupts the summary's role="alert" announcement, so
				// also describe the field by the summary: focus then reads the label,
				// the summary, and the field's own error.
				if (summary.id) {
					var describedBy = (control.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean);
					if (describedBy.indexOf(summary.id) === -1) {
						describedBy.unshift(summary.id);
						control.setAttribute('aria-describedby', describedBy.join(' '));
					}
				}

				// GF focuses the summary in a setTimeout(0); run after it
				setTimeout(function () {
					control.focus();
				}, 100);
			}
		});
	},
};
